import type { IconData } from '@stacksjs/iconify-core'

export const fiverrCircle: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.427 13.148v-5h-5v-.312c0-.517.42-.938.938-.938h.937V5.023h-.937a2.816 2.816 0 0 0-2.813 2.813v.312h-1.25v1.875h1.25v3.125h-1.25v1.875h4.375v-1.875h-1.25v-3.125h3.143v3.125h-1.268v1.875h4.375v-1.875z\"/><circle cx=\"12.402\" cy=\"5.971\" r=\"1.001\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default fiverrCircle
